import axios from 'axios'

axios.defaults.withCredentials = true;

const API_BASE_URL = process.env.VUE_APP_API_URL || '';

const config = {
    baseUrl: API_BASE_URL + "/gsapi/gs25List/" 
};

const gs25ListAPI = {
    searchGs25Store: (conditions = {}, paths) => {
        const uri = paths || "searchGs25Store";
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    }
};

export { gs25ListAPI };